<template>
  <div>
    <div></div>

    <div class="el-tree-main">
      <!-- <div class="tree_title">
        <i class="el-icon-menu"></i>
      <span>部门列表</span>-->
      <el-input
        v-model="form.searchValue"
        @change="serch"
        placeholder="搜索仓库"
        suffix-icon="el-icon-zoom-in"
      />
      <div
        class="item"
        @click="clickItem(d,i)"
        :class="{active:i == activeIndex}"
        v-for="(d,i) in treeList"
        :key="d.bizCode"
      >{{ d.name}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'treeNav',
  props: {
    treeList: {
      type: Array,
      default: [],
    },
  },
  components: {},
  data() {
    return {
      form: { searchValue: '' },
      activeIndex: 0,
    }
  },
  watch: {},
  created() {
    console.log(this.treeList, '-------------------')
  },
  methods: {
    serch() {
      this.$emit('onsearch', this.form.searchValue)
    },
    clickItem(d, i) {
      console.log(d, '-------------------')
      this.activeIndex = i

      this.$emit('ontree', d.bizCode)
      this.$emit('ontreename', d.name)

    },
  },
}
</script>

<style lang='less' scoped>
// @import '~@/assets/variables.less';
.item {
  height: 45px;
  width: 100%;
  text-align: center;
  line-height: 45px;
  border-bottom: 1px solid rgb(138, 134, 134);
  cursor: pointer;
}
.active {
  color: #c59429;
}
</style>
